import { StyleImageInterface } from './StyleImageInterface'
import { calculateIconColor } from './common'

export default function JobClusterPin(
  name: string,
  { scale = 1, pixelRatio = 4 } = {}
): StyleImageInterface {
  const pinDetails = name.split('__')
  const fill = pinDetails[1]
  const baseSize = 24

  const pointCount = pinDetails[2] || 0
  let sizeModifier = 1.5
  if (pointCount > 300) {
    sizeModifier = 2
  } else if (pointCount > 100) {
    sizeModifier = 1.75
  } else if (pointCount > 50) {
    sizeModifier = 1.5
  }

  const size = baseSize * sizeModifier * pixelRatio * scale
  const strokeWidth = 1.35
  const strokeColor = '#3c3d3f'

  return {
    width: size,
    height: size,
    data: new Uint8Array(size * size * pixelRatio),

    async onAdd(map) {
      this.map = map
      const canvas = document.createElement('canvas')
      canvas.width = size
      canvas.height = size
      const context = canvas.getContext('2d')!

      context.strokeStyle = strokeColor
      context.lineWidth = strokeWidth * pixelRatio
      context.fillStyle = fill

      const radius = size / 2 - strokeWidth * pixelRatio
      context.beginPath()
      context.arc(size / 2, size / 2, radius, 0, 2 * Math.PI)
      context.stroke()
      context.fill()

      context.fillStyle = calculateIconColor(fill)
      this.data = context.getImageData(0, 0, this.width, this.height).data
    },

    render() {
      if (!this.initialized) {
        this.initialized = true

        return true
      }

      return false
    },
  }
}
